import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Pencil, Check, X, Plus, Trash } from 'lucide-react';

const SkillsSection = ({ skills, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedSkills, setEditedSkills] = useState(skills.map(skill => ({
    id: skill.id || Date.now(),
    name: skill.name
  })));

  const handleAddSkill = () => {
    setEditedSkills([...editedSkills, { id: Date.now(), name: '' }]);
  };

  const handleRemoveSkill = (id) => {
    setEditedSkills(editedSkills.filter(skill => skill.id !== id));
  };

  const handleSkillChange = (id, value) => {
    setEditedSkills(editedSkills.map(skill =>
      skill.id === id ? { ...skill, name: value } : skill
    ));
  };

  const handleSave = () => {
    onUpdate(editedSkills);
    setIsEditing(false);
  };

  return (
    <div className="profile-section">
      <div className="flex justify-between items-center mb-4">
        <h2 className="section-title">Skills</h2>
        {!isEditing ? (
          <Button variant="ghost" size="sm" onClick={() => setIsEditing(true)}
            className="text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white">
            <Pencil className="w-4 h-4" />
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={() => setIsEditing(false)}>
              <X className="w-4 h-4" />
            </Button>
            <Button variant="ghost" size="sm" onClick={handleSave}>
              <Check className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>

      <div className="space-y-2">
        {(isEditing ? editedSkills : skills).map((skill) => (
          <div key={skill.id} className="flex items-center gap-2">
            {isEditing ? (
              <>
                <Input
                  value={skill.name}
                  onChange={(e) => handleSkillChange(skill.id, e.target.value)}
                  placeholder="Enter skill"
                  className="flex-1"
                />
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleRemoveSkill(skill.id)}
                  className="text-red-500"
                >
                  <Trash className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full text-sm">
                {skill.name}
              </span>
            )}
          </div>
        ))}
        {isEditing && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleAddSkill}
            className="w-full mt-2"
          >
            <Plus className="w-4 h-4 mr-2" /> Add Skill
          </Button>
        )}
      </div>
    </div>
  );
};

export default SkillsSection;
